<template>
  <v-tooltip
    v-if="tooltip"
    top
  >
    <template v-slot:activator="{ on }">
      <v-icon
        class="clickable-row"
        :color="color"
        :small="isSmall"
        v-on="on"
      >
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
  <v-icon
    v-else
  >
    {{ icon }}
  </v-icon>
</template>
<script>
export default {
  props: ["icon", "tooltip", "color", "isSmall"],
};
</script>
